import React from 'react'

import { Box } from 'components/ds'
import DiscoCallout from 'components/ds/DiscoCallout'
import InlineLink from 'components/ui/inline-link'

export type PasswordWarningProps = {
  isPlaylist: boolean
  playlistPassword?: string
  autoEmailSharedPlaylistPasswords?: boolean
  isEmailTab: boolean
}

const DISCO_INBOX_NOTE =
  'Note: Password protection is not supported when sending to DISCO inboxes.'

export function PasswordWarning({
  isPlaylist,
  playlistPassword,
  autoEmailSharedPlaylistPasswords,
  isEmailTab,
}: PasswordWarningProps) {
  // Only show for playlists with non-empty passwords
  if (!isPlaylist || !playlistPassword?.length) {
    return null
  }

  // Assign URL tab - password must be provided separately
  if (!isEmailTab) {
    return (
      <Box mb="4">
        <DiscoCallout type="warning" size="2" variant="soft">
          This Playlist is password protected, you will need to provide it to
          recipients of assigned URLs. You can find the password on the Security
          tab.
        </DiscoCallout>
      </Box>
    )
  }

  // Email tab - message varies based on auto-email setting
  const emailMessage = autoEmailSharedPlaylistPasswords ? (
    <>
      This Playlist is password protected. We will include the password in the
      email sent to recipients.
    </>
  ) : (
    <>
      This Playlist is password protected. Your business is not configured to
      send the password in the email sent to recipients. You will need to
      distribute the password separately or{' '}
      <InlineLink to="/settings/business">change the setting here</InlineLink>{' '}
      before sharing.
    </>
  )

  return (
    <Box mb="4">
      <DiscoCallout type="warning" size="2" variant="soft">
        {emailMessage}
        <br />
        <br />
        {DISCO_INBOX_NOTE}
      </DiscoCallout>
    </Box>
  )
}

export default PasswordWarning
